// Store for auth and connection
import { SignalWire } from '@signalwire/client'
import type {
  SignalWireClientParams,
  SignalWireClient,
} from '@signalwire/client'
import { create, type StateCreator } from 'zustand'
import { logger } from '@/logger/createLogger'
import { useUserStore } from '@/stores/user'

interface Actions {
  actions: {
    setHost: (host: string) => void
    startApp: (accessToken: string, debug?: boolean) => Promise<void>
  }
}

interface State {
  client: SignalWireClient | null
  host: string
}

type Store = Actions & State

const initialState: State = {
  client: null,
  host: '',
}

const stateCreatorFn: StateCreator<Store> = (set, get) => ({
  ...initialState,
  actions: {
    setHost: (host: string) => {
      set({ host: host.trim() })
    },
    startApp: async (accessToken, debug = false) => {
      const { host } = get()

      if (!accessToken || !host) {
        throw new Error('Missing access token or host')
      }
      logger.debug('XXXX: Starting using host:', host)

      // TODO: Add try/catch?
      let clientParams: SignalWireClientParams = {
        host,
        token: accessToken,
      }

      // FIXME: This is a temporary workaround to allow debugging in all environments.
      // if (ENV_VARS.IS_DEVELOPMENT ?? debug) {
      logger.warn(`debug ${debug} by passed`)
      clientParams = {
        ...clientParams,
        debug: { logWsTraffic: true },
        logLevel: 'debug',
      }
      //}

      logger.info('Starting SignalWire client with params:', clientParams)

      const client = await SignalWire(clientParams)

      set({ client })

      // fetch and set the initial user state
      await useUserStore.getState().actions.refreshSubscriberState()
    },
  },
})

export const useMainStore = create<Store>()(stateCreatorFn)
export const useMainStoreActions = () => useMainStore.getState().actions
